import { bl_fi_tax_txn_RowClass } from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";



export class TaxTxnsContainerModel extends BaseContainerModel {
    bl_fi_tax_txn: bl_fi_tax_txn_RowClass = new bl_fi_tax_txn_RowClass();
  }